import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Submit BatchFile Rupe Payment
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchpaymentrupesubmit
*/
export const submitBatchFileRupePayment = payload => {
	return httpClient({
		method: 'POST',
		url: 'batch/payment/rupe/submit',
		data: payload,
		operationTypeId: 4100000 /* for mocks handling of tokens */
	})
}

/** Get Batch Payments List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchpaymentlist
*/
export const requestBatchPaymentsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'batch/payment/list',
        params: payload,
		isCancellable: true
	})
}

/** Get Batchfile Transfer Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchpayment%7BbatchPaymentId%7Ddetail
*/
export const requestBatchPaymentDetail = batchPaymentId => {
	return httpClient({
		method: 'GET',
		url: `batch/payment/${batchPaymentId}/details`,
		isCancellable: true
	})
}

/** Create Batch Download Receipt Url
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchpayment%7BbatchPaymentId%7Dreceipt
*/
export const createBatchPaymentDownloadReceiptUrl = batchPaymentId => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `batch/payment/${batchPaymentId}/receipt`
	})
}

/** Create Batch Payment Zip
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchpayment%7BbatchPaymentId%7Dzip
*/
export const createBatchPaymentZip = batchPaymentId => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `batch/payment/${batchPaymentId}/zip`
	})
}

/** Requests batch payment status
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchpaymentstatuses
*/
export const requestBatchPaymentStatus = payload => {
	return httpClient({
		method: 'GET',
		url: 'batch/payment/statuses'
	})
}

/** Create Batch Payment Zip by Email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchpayment%7BbatchPaymentId%7Dzipemail
*/
export const sendBatchPaymentZipByEmail = payload => {
	return httpClient({
		method: 'POST',
		url: `batch/payment/${payload.id}/zip/email`,
        data: payload.data
	})
}

/** Create Batch Payment Notification by Email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchpayment%7BbatchPaymentId%7Dnotificationemail
*/
export const requestBatchPaymentNotificationByEmail = payload => {
	return httpClient({
		method: 'POST',
		url: `batch/payment/${payload.id}/notification/email`,
		data: payload.data
	})
}

/** Create Batch Payment Notification by Email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_batchpayment%7BbatchPaymentId%7Dnotificationsms
*/
export const requestBatchPaymentNotificationBySms = payload => {
	return httpClient({
		method: 'POST',
		url: `batch/payment/${payload.id}/notification/sms`,
        data: payload.data
	})
}
